import { defineStore } from 'pinia';

export const useTermsStore = defineStore({
    id: "useTermsStore",
    state: () => ({
        rootUrl: '/api/Terms/',
        terms: null as any
    }),
    actions: {
        async getTerms() {
            const response = await this.axiosFactory
                .withoutToken()
                .get(`${this.$state.rootUrl}GetTerms`);

            if (response.data) {
                this.terms = JSON.parse(response.data.data);
            }
        }
    }
})